var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"my-3",attrs:{"cols":"12","sm":"2"}},[_c('v-btn',{attrs:{"to":{ name: _vm.route }}},[_vm._v("Back")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }